import * as pdfjs from "pdfjs-dist";

const PDF_WORKER_SRC = "/pdf.worker.min.js";

let workerConfigured = false;
let workerVerificationPromise: Promise<void> | null = null;

async function verifyPdfWorkerInDev() {
  if (!import.meta.env.DEV || typeof fetch === "undefined") {
    return;
  }

  const response = await fetch(PDF_WORKER_SRC);
  if (!response.ok) {
    throw new Error(`Failed to load PDF worker asset (${response.status})`);
  }

  const contentType = response.headers.get("content-type")?.toLowerCase() ?? "";
  if (contentType.includes("text/html")) {
    throw new Error("PDF worker asset resolved to HTML instead of JavaScript");
  }
}

export function resetPdfWorkerForTests() {
  workerConfigured = false;
  workerVerificationPromise = null;
  pdfjs.GlobalWorkerOptions.workerPort = null;
  pdfjs.GlobalWorkerOptions.workerSrc = "";
}

export async function ensurePdfWorkerConfigured() {
  if (workerConfigured) {
    return;
  }

  pdfjs.GlobalWorkerOptions.workerSrc = PDF_WORKER_SRC;

  if (typeof Worker === "undefined") {
    workerConfigured = true;
    return;
  }

  workerVerificationPromise ??= verifyPdfWorkerInDev().catch((error) => {
    workerVerificationPromise = null;
    throw error;
  });
  await workerVerificationPromise;
  workerConfigured = true;
}

export function getPdfWorkerSrc() {
  return PDF_WORKER_SRC;
}
